// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e-guaranteed[data-v-4ace91ca] {
  background-color: var(--4ace91ca-guaranteedColor);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/VehicleSaverLeasing.vue","webpack://./VehicleSaverLeasing.vue"],"names":[],"mappings":"AACA;EACE,iDAAA;EACA,YAAA;ACAF","sourcesContent":["\r\n.e-guaranteed {\r\n  background-color: v-bind(guaranteedColor);\r\n  color: white;\r\n}\r\n",".e-guaranteed {\n  background-color: v-bind(guaranteedColor);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
